// extracted by mini-css-extract-plugin
export default {"page":"view_page__Wn9U+","tableWrapper":"view_tableWrapper__mdLVW","pageHeader":"view_pageHeader__CdbW5","noData":"view_noData__ADmhZ","buttonWrapper":"view_buttonWrapper__89kxb"};